<div
  (drop)="DropHandler($event)"
  (dragleave)="RemoveHovering()"
  (dragover)="DragOverHandler($event)"
  class="downloadbox"
  [ngClass]="{ hovering: Hovering, disabled: Disabled }"
  (click)="OpenFileDialog(undefined, IsMultiple)"
  *ngIf="!HideDragDrop"
>
  <div class="main-icon">
    <fa-icon class="drag-icon" [icon]="icon"></fa-icon>
  </div>

  <div class="text mt-[16px]">
    {{ DragText }}
  </div>
</div>

<div
  *ngFor="let file of files; let index = index"
  class="file-holder"
  [ngClass]="{ 'border-dashed': !files, disabled: Disabled }"
>
  <ng-container *ngIf="file.url">
    <img
      *ngIf="isPdf()"
      src="../../../../../assets/pdf-icon.png"
      class="w-[25px] h-[25px] cursor-pointer"
      (click)="showImage(file.fileName, file.url)"
    />
    <img
      *ngIf="!isPdf()"
      src="{{ file.url }}"
      class="w-[25px] h-[25px] cursor-pointer"
      (click)="showImage(file.fileName, file.url)"
    />
  </ng-container>

  <div class="flex-1">{{ file.fileName }}</div>
  <fa-icon
    class="text-dark-20 cursor-pointer"
    (click)="RemoveFile(index)"
    [icon]="trash"
  ></fa-icon>
  <fa-icon class="text-green-Secondary" [icon]="faCheck"></fa-icon>
</div>
<div
  class="file-holder border-dashed"
  *ngIf="(IsMultiple || files.length === 0) && showAddButton"
  [ngClass]="{ disabled: Disabled }"
>
  <fa-icon class="text-green-Secondary" [icon]="addIcon"></fa-icon>
  <div
    (click)="OpenFileDialog(this.files.length)"
    class="flex-1 cursor-pointer"
  >
    Add
  </div>
</div>

<input type="file" hidden #fileInput />
